import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import * as Sentry from "@sentry/vue";
import "animate.css";

import "./assets/main.css";

const app = createApp(App);

app.use(router);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: "https://04cd0509ba694e9b92bf7693ded9a104@o4505583323643904.ingest.sentry.io/4505583325806592",
    integrations: [
      new Sentry.BrowserTracing({
        // Propagate distributed-tracing headers to our backend (the API the
        // overlay calls for SSE/config).
        tracePropagationTargets: ["localhost", "https://api.liverequests.app"],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      // Session Replay intentionally disabled: a 24/7 overlay would burn through
      // the free-tier replay quota for little value. Errors + traces are enough.
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Sample 10% of transactions; overlays run continuously per stream
  });
  app.config.errorHandler = (err, vm, info) => {
    Sentry.captureException(err);
  };
}

app.mount("#app");
